// extracted by mini-css-extract-plugin
export var orderSummary = "_nr-0";
export var showMoreLessButton = "_nr-1";